import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AdminLayout } from '@/pages/admin/layout/AdminLayout';
import { AppLayoutSkeleton } from '@/layout/AppLayoutSkeleton';
import { requireAuthenticated } from '@/lib/auth/authSnapshot';

export const Route = createFileRoute('/admin')({
  component: AdminLayoutRoute,
  // Same pending boundary as $slug (see the comment there): no delay, no minimum.
  pendingComponent: AppLayoutSkeleton,
  pendingMs: 0,
  pendingMinMs: 0,
  beforeLoad: () => {
    const auth = requireAuthenticated();

    // Check if user is a superadmin
    if (!auth.isSuperAdmin) {
      // Redirect regular users to their organization page
      throw redirect({
        to: '/$slug',
        params: { slug: auth.slug }
      });
    }

    return {};
  }
});

function AdminLayoutRoute() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
